
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTestContext } from "../context/TestContext";
import { useAuthContext } from "../context/AuthContext";
import {useBottomNavbarContext} from "../context/BottomNavBarContext";

const navigationLinks = [
    { title: "My Profile", link: "/my-profile" },
  ];



const productType = [
  { title: "Home", value: "Home" },
  { title: "Tests", value: "Test" },
  { title: "Packages", value: "Package" },
  { title: "Radiology", value: "Radiology" },
];

const BottomNavbar = () => {

  const { 
    isHomeActive, 
    isTestsActive, 
    isPackagesActive, 
    isRadiologyActive, 
    isProfileActive, 
    activateTab 
  } = useBottomNavbarContext(); 
    const { selectedProductType, setSelectedProductType } = useTestContext();

    const {
      setIsAuth,
      isLoggedIn,
    } = useAuthContext();


    const handleHomeClick = () => {
      setSelectedProductType(productType[0].value);
      activateTab("home"); // Use activateTab from context
    };
  
    const handleTestsClick = () => {
      setSelectedProductType(productType[1].value);
      activateTab("tests"); // Use activateTab from context
    };
  
    const handlePackagesClick = () => {
      setSelectedProductType(productType[2].value);
      activateTab("packages"); // Use activateTab from context
    };
  
    const handleRadiologyClick = () => {
      setSelectedProductType(productType[3].value);
      activateTab("radiology"); // Use activateTab from context
    };
  
    const handleProfileClick = () => {
      activateTab("profile"); // Use activateTab from context
    };


    return (
        <div className="fixed bottom-0 right-0 left-0 lg:hidden z-40 h-[80px] w-full shadow-[0_-4px_6px_0_rgba(0,0,0,0.1)]  bg-white">
            <div className="flex flex-row justify-evenly items-center w-full h-full">
            <Link to={"/"}>
                <div className={`flex flex-col items-center h-full justify-center font-semibold text-[11px] cursor-pointer ${isHomeActive?"text-[#22282F]":"text-[#57636C]"}`} onClick={handleHomeClick}>
                   {!isHomeActive?( <img src="/assets/home-icon.svg" alt="" className="mb-1"/>):( <img src="/assets/home-dark-icon.svg" alt="" className="mb-1"/>)}
                    Home
                </div>
                </Link>
                <Link to={"/"}>
                <div className={`flex flex-col items-center font-semibold text-[11px] cursor-pointer ${isTestsActive?"text-[#22282F]":"text-[#57636C]"}`} onClick={handleTestsClick}>
                    {!isTestsActive?( <img src="/assets/tests-icon.svg" alt="" className="mb-1"/>):( <img src="/assets/tests-dark-icon.svg" alt="" className="mb-1"/>)}
                    Tests
                </div>
                </Link>
                <Link to={"/"}>
                <div className={`flex flex-col items-center font-semibold text-[11px] cursor-pointer ${isPackagesActive?"text-[#22282F]":"text-[#57636C]"}`} onClick={handlePackagesClick}>
                    {!isPackagesActive?( <img src="/assets/package-icon.svg" alt="" className="mb-1"/>):( <img src="/assets/package-dark-icon.svg" alt="" className="mb-1"/>)}
                    Packages
                </div>
                </Link>
                <Link to={"/"}>
                <div className={`flex flex-col items-center font-semibold text-[11px] cursor-pointer ${isRadiologyActive?"text-[#22282F]":"text-[#57636C]"}`} onClick={handleRadiologyClick}>
                    {!isRadiologyActive?( <img src="/assets/radiology-icon.svg" alt="" className="mb-1"/>):( <img src="/assets/radiology-dark-icon.svg" alt="" className="mb-1"/>)}
                    Radiology
                </div>
                </Link>
                {isLoggedIn ? (
                    <Link to={navigationLinks[0].link}>
                    <div className={`flex flex-col items-center font-semibold text-[11px] cursor-pointer ${isProfileActive?"text-[#22282F]":"text-[#57636C]"}`} onClick={handleProfileClick}>
                       {!isProfileActive?( <img src="/assets/profile-icon.svg" alt="" className="mb-1"/>):( <img src="/assets/profile-dark-icon.svg" alt="" className="mb-1"/>)}
                        Profile
                    </div>
                    </Link>
                ):(
                  <div className={`flex flex-col items-center font-semibold text-[11px] cursor-pointer ${isProfileActive?"text-[#22282F]":"text-[#57636C]"}`} onClick={()=>{handleProfileClick(); setIsAuth(true)}}>
                     {!isProfileActive?( <img src="/assets/profile-icon.svg" alt="" className="mb-1"/>):( <img src="/assets/profile-dark-icon.svg" alt="" className="mb-1"/>)}
                      Profile
                  </div>
                )}
            </div>
        </div>
    )
}

export default BottomNavbar;